{{#if isPipelinedWrite}}
{{#with responseSequenceHandle}}
virtual task send_response({{#each createRandomFunctionArgumentHandles delimeter=", "}}{{ type }} {{ identifier }}{{/each}});
  {{> (partial "snippets/start-sequence") context=. declareType=true}}
{{/with}}
  {{ configHandle.identifier }}.retire_request_grant();
  {{ configHandle.identifier }}.retire_data_grant();
endtask
{{/if}}
